import * as React from "react";
import { User } from "../api/classes";
import { Avatar, Typography, Select, MenuItem } from "@material-ui/core";
import { connect } from "react-redux";
import { GlobalState } from "../store";
import { RouteComponentProps } from "react-router-dom";
import * as actions from "../store/cases/actions";
import { DEFAULT_AVATAR } from "src/auth/auth";

interface Props {
  id: number;
  user?: User;
  users: User[];
  style: React.CSSProperties;
  small?: boolean;
  readOnly: boolean;
  fetchUser: () => void;
  onSelect: (id) => void;
}
interface State {}
class UserSelect extends React.Component<Props, State> {
  componentWillMount() {
    if (!this.props.user && !this.props.small) {
      this.props.fetchUser();
    }
  }
  handleUserChange = e => {
    if (this.props.onSelect) {
      this.props.onSelect(e.target.value);
    }
  };
  render() {
    const { user, users, small, readOnly } = this.props;
    if (users) {
      if (readOnly) {
        return (
          <div
            style={{
              ...this.props.style,
              position: "relative",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 28
            }}
          >
            <Avatar
              style={{
                width: 20,
                height: 20,
                marginRight: 12
              }}
              src={
                user && user.account_picture
                  ? user.account_picture
                  : DEFAULT_AVATAR
              }
            />
            <Typography variant="body2" style={{ fontSize: small && 13 }}>
              {user ? user.name : "No Assignee"}
            </Typography>
          </div>
        );
      }
      if (small) {
        return (
          <div
            style={{
              ...this.props.style,
              position: "relative"
            }}
          >
            <Avatar
              style={{
                position: "absolute",
                left: 0,
                top: 3,
                width: 20,
                height: 20
              }}
              src={
                user && user.account_picture
                  ? user.account_picture
                  : DEFAULT_AVATAR
              }
            />
            <Select
              disableUnderline
              style={{
                alignSelf: "flex-start",
                paddingLeft: 28,
                fontSize: 13
              }}
              value={this.props.user ? this.props.user.id : "-"}
              onChange={this.handleUserChange}
              inputProps={{
                name: "age",
                id: "age-simple"
              }}
            >
              <MenuItem value="-" disabled>
                Assign User
              </MenuItem>
              {this.props.users.map(u => {
                return (
                  <MenuItem key={u.id} value={u.id}>
                    {u.name}
                  </MenuItem>
                );
              })}
            </Select>
          </div>
        );
      }
      return (
        <div
          style={{
            ...this.props.style,
            position: "relative"
          }}
        >
          <Avatar
            style={{
              position: "absolute",
              left: 0,
              top: 5,
              width: 20,
              height: 20
            }}
            src={
              user && user.account_picture
                ? user.account_picture
                : DEFAULT_AVATAR
            }
          />
          <Select
            disableUnderline
            style={{
              alignSelf: "flex-start",
              paddingLeft: 32
            }}
            value={this.props.user ? this.props.user.id : "-"}
            onChange={this.handleUserChange}
            inputProps={{
              fontSize: 13
            }}
          >
            <MenuItem value="-" disabled>
              Assign User
            </MenuItem>
            {this.props.users.map(u => {
              return (
                <MenuItem key={u.id} value={u.id}>
                  {u.name}
                </MenuItem>
              );
            })}
          </Select>
        </div>
      );
    } else {
      return null;
    }
  }
}
export default connect(
  (state: GlobalState, own: Props) => ({
    users:
      state.cases.users &&
      state.cases.users
        .filter(a => a.status === "active" && a.role_id > 0)
        .sort((a, b) => a.name.localeCompare(b.name)),
    user: state.cases.users && state.cases.users.find(i => i.id === own.id)
  }),
  dispatch => ({
    fetchUser: (): any => dispatch(actions.fetchUsers())
  })
)(UserSelect);



// WEBPACK FOOTER //
// ./src/components/userSelect.tsx